import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const normalizeRow = (row, delimiter = ', ') => {
  if (!row) return {};
  return Object?.fromEntries(
    Object?.entries(row)?.map(([key, value]) => {
      if (Array.isArray(value)) {
        if (value?.length == 0) return [key, '-'];

        if (value?.length && typeof value?.[0] === 'object') {
          return [key, value?.map((o) => JSON.stringify(o))?.join('; ')];
        }

        return [key, value?.map((x) => (x == null ? '' : x))?.join(delimiter)];
      }
      if (value && typeof value === 'object' && !(value instanceof Date)) {
        return [key, JSON.stringify(value)];
      }

      return [key, value ?? '-'];
    })
  );
};

const exportToExcel = (data, fileName) => {
  if (!data.length) {
    return;
  }
  const flat = data?.map((d) => normalizeRow(d));

  const headers = Object.keys(flat?.[0]);

  const worksheet = XLSX.utils.json_to_sheet(flat, { header: headers });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(dataBlob, `${fileName}.xlsx`);
};

export default exportToExcel;
